import type { ComponentPropsWithoutRef, ReactNode } from "react";

type AdminTableProps = ComponentPropsWithoutRef<"table"> & {
  containerClassName?: string;
  footer?: ReactNode;
  toolbar?: ReactNode;
};

function cn(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

export function AdminTable({
  children,
  className,
  containerClassName,
  footer,
  toolbar,
  ...tableProps
}: AdminTableProps) {
  return (
    <section
      className={cn(
        "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm",
        containerClassName,
      )}
    >
      {toolbar ? (
        <div className="border-b border-slate-200">{toolbar}</div>
      ) : null}
      <div className="overflow-x-auto">
        <table
          {...tableProps}
          className={cn(
            "w-full min-w-200 text-left text-sm",
            "[&_thead]:border-b [&_thead]:border-slate-200 [&_thead]:bg-slate-50 [&_thead]:text-xs [&_thead]:font-semibold [&_thead]:text-slate-500",
            "[&_th]:px-4 [&_th]:py-3 [&_th]:align-middle",
            "[&_tbody]:divide-y [&_tbody]:divide-slate-100 [&_tbody]:bg-white [&_tbody]:text-slate-700",
            "[&_td]:px-4 [&_td]:py-3 [&_td]:align-middle",
            "[&_tbody>tr]:transition-colors [&_tbody>tr:hover]:bg-slate-50",
            "[&_a]:font-medium [&_a]:text-slate-900 [&_a:hover]:text-blue-700 [&_a:hover]:underline",
            className,
          )}
        >
          {children}
        </table>
      </div>
      {footer}
    </section>
  );
}